import React from 'react';

import { Link, NavLink } from 'react-router-dom';
import { listStyles } from './styles';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import PText from 'components/Primatives/PText'; 

/*

Props:

• titleText
• data
• style
• faIconZ2
• faIcon
• iconSize

*/

const _applyStyleModifiers = (props) => {
    // const { logoURL, size } = props;
    const styles = listStyles;
    
    return { ...styles, container: { ...styles.container, ...props.style } };
}

// const _stringModifier = (props) => {
//     let modifiedTitle = props.mainTitleText;
    
//     if(props.mainTitleText){
//         if (props.mainTitleTextAlt) {
//             modifiedTitle = props.mainTitleText + ' | ';
//         }
//     } else {
//         modifiedTitle = '';
//     }

//     return modifiedTitle;
// }

export const List = (props) => {
    
    // const mainTitleText = _stringModifier(props);
    console.log('ICONS', props.faIcon, props.faIconZ2);
    
    const styles = _applyStyleModifiers(props);
    // TODO: Convert string into array of paragraphs using const myArray = props.bodyText.split('\n') then loop over array adding div for each with required spacing
    let items;
   
    if (props.data) {
        items = props.data ;
    } else if (props.children) {
        items = props.children;
    }

    return (
        <div>
            <div style={ styles.container }>

                { props.titleText && <span style={ styles.title }>
                    { props.titleText }
                </span>}
                <div style={styles.listItemStyle}>
                    { items.map((item, i) => {
                        let checkFontSize = props.iconSize/2.5;
                        return (
                            <div key={i} style={ styles.itemContainer}>
                                { props.faIconZ2 &&
                                    <FontAwesomeIcon 
                                        icon={props.faIconZ2} 
                                        className={props.faIcon} 
                                        style={{...styles.iconStyle, marginRight: -(props.iconSize - checkFontSize + (checkFontSize/4)), fontSize: checkFontSize, color: 'white', zIndex: 2 }}
                                    />
                                }
                                <FontAwesomeIcon 
                                    icon={['fas', props.faIcon]}
                                    className={props.faIcon} 
                                    style={ {...styles.iconStyle, fontSize: props.iconSize} }
                                />
                                <span style={{ lineHeight: 1.3, }}>
                                    {item}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div> 
    );
};


// WEBPACK FOOTER //
// ./src/js/components/List/List.jsx